/**
 * Telegram file URL helper.
 *
 * Telegram file URLs are temporary (signed, expire in ~1h). Frontend never
 * calls Telegram directly — that would expose the bot token. Instead:
 *
 *   1. Cloudflare Worker (admin API) caches Telegram file URLs in memory
 *      and exposes /api/telegram/file/:file_id → redirect to current URL.
 *   2. Frontend just constructs the path /api/telegram/file/<file_id>
 *
 * If the Worker is not available (e.g. local dev without worker), we fall
 * back to /api/photo/<photo_id>/image which the Worker should also serve.
 */

const ADMIN_API = import.meta.env.VITE_ADMIN_API_URL ?? '/api/admin';

function adminBase(): string {
  // ADMIN_API_URL may end with /api/admin; strip that to get root
  return ADMIN_API.replace(/\/api\/admin\/?$/, '');
}

export function telegramFileUrl(fileId: string | null | undefined): string {
  if (!fileId) return '';
  return `${adminBase()}/api/telegram/file/${encodeURIComponent(fileId)}`;
}

export function photoImageUrl(photoId: string): string {
  return `${adminBase()}/api/photo/${photoId}/image`;
}
